import { render, staticRenderFns } from "./SegmentConfig.vue?vue&type=template&id=f1c22fde&scoped=true"
import script from "./SegmentConfig.vue?vue&type=script&lang=js"
export * from "./SegmentConfig.vue?vue&type=script&lang=js"
import style0 from "./SegmentConfig.vue?vue&type=style&index=0&id=f1c22fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c22fde",
  null
  
)

export default component.exports